import clsx from "clsx";
import React from "react";
import "./styles.scss";

const Title = (props) => {
  const { content, color, position, subContent, className } = props;
  const shouldRenderSub = !!subContent;
  return (
    <div className={clsx("Title comp-wrap", className)}>
      <div className="comp-cont">
        <div
          className={clsx("text", color, position === "center" ? "center" : "")}
        >
          {content}
          {shouldRenderSub && (
            <span className="sub-content"> {subContent}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default Title;
